// TODO: Followup Type properly

const notification = ({ data }: { data: any }) => ({
  data,
});

const notifications = ({ data, meta }: { data: any; meta: any }) => ({
  meta,
  data: data.map((dat: any) => notification({ data: dat })?.data),
});

export default { notification, notifications };
